import { NewContentOutDto, NewContentInDto } from '../../../types/content.dto'

export const NEW_CONTENT = 'NEW_CONTENT'
export const NEW_CONTENT_SUCCESS = 'NEW_CONTENT_SUCCESS'
export const NEW_CONTENT_ERROR = 'NEW_CONTENT_ERROR'
export const RESET_NEW_CONTENT = 'RESET_NEW_CONTENT'

export interface NewContent {
  type: typeof NEW_CONTENT
  payload: NewContentOutDto
}

export interface NewContentSuccess {
  type: typeof NEW_CONTENT_SUCCESS
  payload: NewContentInDto
}

export interface NewContentError {
  type: typeof NEW_CONTENT_ERROR
  payload: string | boolean
}

export interface ResetNewContent {
  type: typeof RESET_NEW_CONTENT
  payload: null
}

export interface State {
  data: NewContentInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewContent | NewContentSuccess | NewContentError | ResetNewContent
